<template>
  <v-container class="bank-add-page" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "目标添加" : "目标编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        :max-width='isEdit ? 900 :1100'
      >
        <template v-slot:content>
           <v-card class="px-4" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="3" v-if="!isEdit">
                    <v-radio-group v-model="form.setType" :rules="required" row @change="changeType">
                    <v-radio label="员工" :value="1"></v-radio>
                    <v-radio label="部门" :value="2"></v-radio>
                  </v-radio-group>
                   <v-card v-if="form.setType === 2" height="570" outlined class="overflow-auto">
                    <v-tree-select
                        ref='dept'
                        path='system/dept/tree'
                        v-model="form.setId"
                        selection-type='independent'
                      />
                    </v-card>
                    <v-card v-else height="570" outlined class="overflow-auto">
                      <v-user-list  v-model="form.setId"/>
                    </v-card>
                </v-col>
                <v-col :cols="isEdit ? 12 : 9">
                  <v-row>
                    <v-col cols="6">
                      <v-select
                        v-model="form.targetType"
                        :items="targetTypeItems"
                        label="目标类型"
                        filled rounded  dense
                        :rules="required"
                        hide-details="auto"
                      ></v-select>
                    </v-col>
                    <v-col cols="6">
                       <v-select
                        v-model="form.rangeType"
                        :items="rangeTypeItems"
                        label="目标范围"
                        filled rounded  dense
                        :rules="required"
                        hide-details="auto"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <div v-if="isEdit || (form.rangeType === 1 && form.setId.length > 0)">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field label="全年目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.yearTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="yearTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="6">
                        <v-text-field label="上半年目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.firstHalfTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="firstHalfTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="6">
                        <v-text-field label="下半年目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.secondHalfTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="secondHalfTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="3">
                        <v-text-field label="第一季度目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.firstQuarterTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="firstQuarterTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="第二季度目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.secondQuarterTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="secondQuarterTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3">
                        <v-text-field label="第三季度目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.thirdQuarterTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="thirdQuarterTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="第四季度目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.fourthQuarterTarget">
                          <template v-slot:append>
                            <v-btn fab x-small color="blue-grey" dark class="mt-n1 mr-n4" @click="fourthQuarterTargetPf">
                              均分
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="3">
                        <v-text-field label="一月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.januaryTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="四月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.aprilTarget"></v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3">
                        <v-text-field label="七月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.julyTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="十月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.octoberTarget"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3">
                        <v-text-field label="二月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.februaryTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="五月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.mayTarget"></v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3">
                        <v-text-field label="八月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.augustTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="十一月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.novemberTarget"></v-text-field>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="3">
                        <v-text-field label="三月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.marchTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="六月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.juneTarget"></v-text-field>
                      </v-col>
                      <v-divider vertical></v-divider>
                      <v-col cols="3">
                        <v-text-field label="九月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.septemberTarget"></v-text-field>
                      </v-col>
                      <v-col cols="3">
                        <v-text-field label="十二月份目标" hide-details="auto" :rules="number" filled rounded  dense  v-model="form.decemberTarget"></v-text-field>
                      </v-col>
                    </v-row>
                  </div>

                </v-col>
              </v-row>

            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" rounded :disabled='form.setId.length < 1' :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>

          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/setting/target.js'
  import VTreeSelect from '@/components/select/v-tree-multiple.vue'
  import VUserList from '@/components/select/v-user-list.vue'

  export default {
    name: 'TargetAdd',
    components: {
      VTreeSelect,
      VUserList
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        tab: '',
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => /^[0-99]+.?[0-99]*$/.test(value) || '必须输入数字',
        ],
        targetTypeItems: [
          { text: '合同额', value: 1 },
          // { text: '回款额', value: 2 }
        ],
        rangeTypeItems: [
          { text: '全年目标', value: 1 }
          // { text: '近期目标', value: 2 }
        ],
        form: {
          id: '',
          setType: 1,
          targetType: '',
          rangeType: 1,
          year: '',
          yearTarget: '',
          firstHalfTarget: '',
          secondHalfTarget: '',
          firstQuarterTarget: '',
          secondQuarterTarget: '',
          thirdQuarterTarget: '',
          fourthQuarterTarget: '',
          januaryTarget: '',
          februaryTarget: '',
          marchTarget: '',
          aprilTarget: '',
          mayTarget: '',
          juneTarget: '',
          julyTarget: '',
          augustTarget: '',
          septemberTarget: '',
          octoberTarget: '',
          novemberTarget: '',
          decemberTarget: '',
          setId: []
        },
        defForm: {
          id: '',
          setType: 1,
          targetType: '',
          rangeType: 1,
          year: '',
          yearTarget: '',
          firstHalfTarget: '',
          secondHalfTarget: '',
          firstQuarterTarget: '',
          secondQuarterTarget: '',
          thirdQuarterTarget: '',
          fourthQuarterTarget: '',
          januaryTarget: '',
          februaryTarget: '',
          marchTarget: '',
          aprilTarget: '',
          mayTarget: '',
          juneTarget: '',
          julyTarget: '',
          augustTarget: '',
          septemberTarget: '',
          octoberTarget: '',
          novemberTarget: '',
          decemberTarget: '',
          setId: []
        }
      }
    },
    methods: {
      yearTargetPf () {
        // 上半年
        this.form.firstHalfTarget = Math.ceil(this.form.yearTarget / 2)
        // 下半年
        this.form.secondHalfTarget = Math.ceil(this.form.yearTarget / 2)
        // 季度
        this.setFirstHalf(this.form.yearTarget, 4)
        this.setSecondHalf(this.form.yearTarget, 4)
        // 月份
        this.setFirstQuarter(this.form.yearTarget, 12)
        this.setSecondQuarter(this.form.yearTarget, 12)
        this.setThirdQuarter(this.form.yearTarget, 12)
        this.setFourthQuarter(this.form.yearTarget, 12)
      },
      firstHalfTargetPf () {
        this.setFirstHalf(this.form.firstHalfTarget, 2)
         // 月份
        this.setFirstQuarter(this.form.firstHalfTarget, 6)
        this.setSecondQuarter(this.form.firstHalfTarget, 6)
      },
      secondHalfTargetPf () {
        this.setSecondHalf(this.form.secondHalfTarget, 2)
        // 月份
        this.setThirdQuarter(this.form.secondHalfTarget, 6)
        this.setFourthQuarter(this.form.secondHalfTarget, 6)
      },
      firstQuarterTargetPf () {
        this.setFirstQuarter(this.form.firstQuarterTarget, 3)
      },
      secondQuarterTargetPf () {
        this.setSecondQuarter(this.form.secondQuarterTarget, 3)
      },
      thirdQuarterTargetPf () {
        this.setThirdQuarter(this.form.thirdQuarterTarget, 3)
      },
      fourthQuarterTargetPf () {
        this.setFourthQuarter(this.form.fourthQuarterTarget, 3)
      },
      setFirstHalf (num, pf) {
        this.form.firstQuarterTarget = Math.round(num / pf)
        this.form.secondQuarterTarget = Math.round(num / pf)
      },
      setSecondHalf (num, pf) {
        this.form.thirdQuarterTarget = Math.round(num / pf)
        this.form.fourthQuarterTarget = Math.round(num / pf)
      },
      setFirstQuarter (num, pf) {
        this.form.januaryTarget = Math.ceil(num / pf)
        this.form.februaryTarget = Math.ceil(num / pf)
        this.form.marchTarget = Math.ceil(num / pf)
      },
      setSecondQuarter (num, pf) {
        this.form.aprilTarget = Math.ceil(num / pf)
        this.form.mayTarget = Math.ceil(num / pf)
        this.form.juneTarget = Math.ceil(num / pf)
      },
      setThirdQuarter (num, pf) {
        this.form.julyTarget = Math.ceil(num / pf)
        this.form.augustTarget = Math.ceil(num / pf)
        this.form.septemberTarget = Math.ceil(num / pf)
      },
      setFourthQuarter(num, pf) {
        this.form.octoberTarget = Math.ceil(num / pf)
        this.form.novemberTarget = Math.ceil(num / pf)
        this.form.decemberTarget = Math.ceil(num / pf)
      },
      save () {
        this.form.setIds = `[${this.form.setId.toString()}]`
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      changeType () {
       this.form.deptIds = []
       this.form.userIds = []
      },
      dialogChange (val) {
        this.item.show = val
        if (val && this.isEdit) {
          this.form = JSON.parse(JSON.stringify(this.item.data))
          this.form.setId = this.form.setIds.split(",")
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
          this.form.setType = 1
          this.form.rangeType = 1
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
